import { ToolOutlined } from "@ant-design/icons";
import { FloatButton } from "antd";

import AssetControlActions from "./AssetControlActions";
import AssetErrorActionsAll from "./AssetErrorActionsAll";
import AssetErrorTest from "./AssetErrorTest";

interface ActionMenuProps {
  assetId: string;
  showAssetCommands: boolean;
  hasUnhandledErrors: boolean;
  hasUnresolvedErrors: boolean;
}

const ActionsMenu = ({
  assetId,
  showAssetCommands,
  hasUnhandledErrors,
  hasUnresolvedErrors,
}: ActionMenuProps) => {
  return (
    <FloatButton.Group
      trigger="click"
      type="primary"
      style={{ right: 24, bottom: 24 }}
      icon={<ToolOutlined />}
    >
      {showAssetCommands && <AssetControlActions assetId={assetId} />}
      <AssetErrorTest assetId={assetId} />
      <AssetErrorActionsAll
        hasUnhandledErrors={hasUnhandledErrors}
        hasUnresolvedErrors={hasUnresolvedErrors}
        assetId={assetId}
      />
    </FloatButton.Group>
  );
};

export default ActionsMenu;
